/*
Copyright (c) 2018 Ady Levy
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";
import { translate, startUndoable, crudUpdate } from "ra-core";
import IconCancel from "@material-ui/icons/Cancel";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import _ from "lodash";
import { Button } from "react-admin";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
const statusToHebrew = {
  active: "לאשר",
  decline: "לדחות",
  banned: "לחסום",
};
const styles = (theme) => ({
  deleteButton: {
    color: theme.palette.info.main,
    "&:hover": {
      backgroundColor: fade(theme.palette.error.main, 0.12),
      // Reset on mouse devices
      "@media (hover: none)": {
        backgroundColor: "transparent",
      },
    },
  },
});
const ChangeAccountStatusButtonWithConfirmation = (props) => {
  const [showDialog, setShowDialog] = useState(false);
  const {
    label = "Active User",
    classes = {},
    className,
    icon,
    status = "active",
    record,
    titleSource,
    replaceResource,
  } = props;
  const handleClick = () => {
    setShowDialog(true);
  };
  const handleCloseClick = () => {
    setShowDialog(false);
  };
  const handleActive = (event) => {
    event.preventDefault();
    setShowDialog(false);
    const {
      dispatchCrudUpdate,
      startUndoable,
      resource = "users",
      basePath,
      redirect = "list",
      undoable,
    } = props;
    let newRecord = _.cloneDeep(record);
    newRecord.status = status;
    if (undoable) {
      startUndoable(
        crudUpdate(
          replaceResource ?? resource,
          record.id,
          record,
          basePath,
          redirect
        )
      );
    } else {
      dispatchCrudUpdate(
        replaceResource ?? resource,
        record.id,
        newRecord,
        record,
        basePath,
        redirect
      );
    }
  };

  return (
    <Fragment>
      <Button
        onClick={() => handleClick()}
        label={label}
        className={classnames(
          "ra-create-button",
          classes.deleteButton,
          className
        )}
        key="button"
      >
        <PersonAddIcon />
      </Button>
      <Dialog
        fullWidth
        open={showDialog}
        onClose={() => handleCloseClick()}
        aria-label="Are you sure?"
      >
        <DialogTitle>
          {statusToHebrew[status]} “
          {titleSource ? record[titleSource] : record?.name ?? "– unnamed –"}”
        </DialogTitle>
        <DialogContent>
          <div>
            האם אתה בטוח שאתה רוצה {statusToHebrew[status]} את היוזר הזה?
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={(e) => handleActive(e)}
            label={label}
            className={classnames(
              "ra-create-button",
              classes.deleteButton,
              className
            )}
            key="button"
          >
            {icon ?? <PersonAddIcon />}
          </Button>
          <Button label="ra.action.cancel" onClick={() => handleCloseClick()}>
            <IconCancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

ChangeAccountStatusButtonWithConfirmation.propTypes = {
  basePath: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  dispatchCrudUpdate: PropTypes.func.isRequired,
  label: PropTypes.string,
  record: PropTypes.object,
  redirect: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.func,
  ]),
  resource: PropTypes.string.isRequired,
  startUndoable: PropTypes.func,
  translate: PropTypes.func,
  undoable: PropTypes.bool,
};

export default compose(
  connect(null, { startUndoable, dispatchCrudUpdate: crudUpdate }),
  translate,
  withStyles(styles)
)(ChangeAccountStatusButtonWithConfirmation);
